import React from 'react';
import { Button } from 'primereact/button';

import { RING_CENTRAL_EVENTS } from '../../../../utils/ringCentralDialer';

import { isRingCentralEnabled } from './ringCentral/ringCentralConfig';

type SidebarCallButtonProps = {
  myPermission?: boolean;
};

const SidebarCallButton: React.FC<SidebarCallButtonProps> = ({
  myPermission,
}) => {
  if (myPermission || !isRingCentralEnabled()) {
    return null;
  }

  const openDialpad = () => {
    window.dispatchEvent(new CustomEvent(RING_CENTRAL_EVENTS.OPEN));
  };

  return (
    <div
      className="fixed w-4rem h-4rem sidebar-call-icon pt-2 border-round-md cursor-pointer"
      onClick={openDialpad}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openDialpad();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Open phone dial pad"
    >
      <Button rounded className="p-1">
        <div className="flex justify-content-center w-full h-full align-items-center">
          <i className="pi pi-phone" aria-hidden />
        </div>
      </Button>
      <div className="text-10 mt-1 text-white">Call</div>
    </div>
  );
};

export default SidebarCallButton;
